import React from "react";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";

const useStyles = makeStyles(theme => ({
  paper: {
    marginTop: theme.spacing(5),
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  avatar: {
    margin: theme.spacing(0),
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(0)
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    float: "right"
  },
  formControl: {
    minWidth: "100%"
  },
  mBottom: {
    marginBottom: "20px"
  },
  mTop: {
    marginTop: "5px"
  },
  button: {
    margin: theme.spacing(3, 0, 2)
  }
}));

export default function ParentGuardian() {
  const classes = useStyles();
  const [age, setAge] = React.useState("");

  const handleChange = event => {
    console.log(setAge(event.target.value));
  };

  return (
    <Container component="main" maxWidth="md">
      <CssBaseline />
      <div className={classes.paper}>
        <form className={classes.form} noValidate>
         
          <Grid container spacing={2}>
            
            <Grid item xs={12} sm={12} className={classes.mTop}>
              <Typography>
                PARENT(father) / GUARDIAN(father) INFORMATION
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                required
                fullWidth
                name="fname"
                label="Father's Name"
                type="text"
                id="fname"
                autoComplete="father-name"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                required
                fullWidth
                name="religion"
                label="Religion"
                type="text"
                id="religion"
                autoComplete="religion"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                required
                fullWidth
                name="occupation"
                label="Occupation"
                type="text"
                id="occupation"
                autoComplete="occupation"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <div className="selectInput">
                <FormControl variant="outlined" className={classes.formControl}>
                  <InputLabel id="father-living-status">
                    Living status?
                  </InputLabel>
                  <Select
                    fullWidth
                    labelId="father-living-status"
                    id="father-living-status"
                    value={age}
                    onChange={handleChange}
                    label="Age"
                  >
                    <MenuItem value={`alive`}>ALIVE</MenuItem>
                    <MenuItem value={`dead`}>DEAD</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                required
                fullWidth
                name="age"
                label="Age"
                type="number"
                id="age"
                autoComplete="0"
              />
            </Grid>
            <Grid item xs={12} sm={12} className={classes.mTop}>
              <Typography>
                PARENT(mother) / GUARDIAN(mother) INFORMATION
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                required
                fullWidth
                name="fname"
                label="Mother's Name"
                type="text"
                id="fname"
                autoComplete="father-name"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                required
                fullWidth
                name="religion"
                label="Religion"
                type="text"
                id="religion"
                autoComplete="religion"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                required
                fullWidth
                name="occupation"
                label="Occupation"
                type="text"
                id="occupation"
                autoComplete="occupation"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <div className="selectInput">
                <FormControl variant="outlined" className={classes.formControl}>
                  <InputLabel id="mother-living-status">
                    Living status?
                  </InputLabel>
                  <Select
                    fullWidth
                    labelId="mother-living-status"
                    id="mother-living-status"
                    value={age}
                    onChange={handleChange}
                    label="Age"
                  >
                    <MenuItem value={`alive`}>ALIVE</MenuItem>
                    <MenuItem value={`dead`}>DEAD</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                required
                fullWidth
                name="age"
                label="Age"
                type="number"
                id="age"
                autoComplete="0"
              />
            </Grid>
            <Grid item xs={12} sm={12} className={classes.mTop}>
              <Typography>SIBLINGS INFORMATION</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                required
                fullWidth
                name="noeb"
                label="Number of Elder Brothers"
                type="number"
                id="number-of-elder-brothers"
                autoComplete="number of elder brothers"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                required
                fullWidth
                name="noyb"
                label="Number of Younger brothers"
                type="number"
                id="number-of-younger-brothers"
                autoComplete="0"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                required
                fullWidth
                name="number-of-elder-sisters"
                label="Number of Elder Sisters"
                type="number"
                id="number-of-elder-sisters"
                autoComplete="0"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                required
                fullWidth
                name="number-of-younger-sisters"
                label="Number of younger sisters"
                type="number"
                id="number-of-younger-sisters"
                autoComplete="0"
              />
            </Grid>
          </Grid>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            className={classes.button}
            component={Link}
            to="academic-information"
          >
            Back
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            className={classes.submit}
            component={Link}
            to="certificate"
          >
            Next
          </Button>
        </form>
      </div>
    </Container>
  );
}
